import { Button } from 'react-bootstrap';

type RunDetectionButtonProps = {
  running: boolean;
  onRun: () => void;
};

const RUN = 'Run detection';
const WORKING = 'Running detection…';

function RunDetectionButton({ running, onRun }: RunDetectionButtonProps) {
  return (
    <Button variant="outline-secondary" size="sm" disabled={running} onClick={onRun}>
      {running ? WORKING : RUN}
    </Button>
  );
}

export default RunDetectionButton;
